import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faSortDown, faSortUp} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";
import Select from "react-select";
import {Consts} from "../pages/consts";
import {useContext} from "react";
import InitContext from "../pages/InitContext";

const SortAndAddNew = ({showSorting, sortConfig, onAddDrug, loading, setSortConfig, centerContent}) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);

  const sortOptions = [
    {value: "startDate", label: t("start_date")},
    {value: "productName", label: t("product_name")},
  ];

  const handleSortChange = (key) => {
    const ascending = sortConfig?.key === key ? !sortConfig?.ascending : true;
    setSortConfig({key, ascending});
  };

  const allowedChanging = context?.role === Consts.HCP_PRESCRIBER || context?.role === Consts.PATIENT;

  return(
    <div className="w3-row w3-padding-small drugs-sort-row symptom-sort-row">
      <div className="w3-col s5 drugs-sort-left-col">
        {showSorting ? (
          <div className="symptom-sort-left-group">
            <label className="drugs-sort-label symptom-sort-label">
              {t("sort_by")}:
            </label>
            <div className="flex-aligned-items symptom-sort-controls">
              <Select
                onChange={(selectedOption) => handleSortChange(selectedOption?.value)}
                value={sortOptions?.find((option) => option?.value === sortConfig?.key)}
                options={sortOptions}
                placeholder={t("select")}
                className="custom-select meds-sort-select symptom-sort-select drugs-sort-select-local"
                classNamePrefix="meds-sort-select"
                isSearchable={false}
              />
              <button
                type="button"
                className="symptom-ui-button symptom-ui-button--icon symptom-ui-button--secondary symptom-sort-order-button"
                onClick={() => handleSortChange(sortConfig?.key)}
                aria-label={t("toggle_sort_direction", { defaultValue: "Change sorting direction" })}
              >
                <FontAwesomeIcon
                  icon={sortConfig?.ascending ? faSortUp : faSortDown}
                  className="drugs-sort-icon symptom-sort-order-icon"
                />
              </button>
            </div>
          </div>
        ) : (
          <div className="w3-container"></div>
        )}
      </div>
      <div className="w3-col s3 w3-center drugs-sort-center-col">
        {centerContent}
      </div>
      <div className="w3-col s4 w3-right-align symptom-sort-action-col">
        <div className="symptom-toolbar-actions">
          {(onAddDrug && !loading && allowedChanging) && (
            <button
              type="button"
              className="symptom-ui-button symptom-ui-button--primary responsive-button"
              onClick={onAddDrug}
            >
              <FontAwesomeIcon icon={faPlus} />
              <span className="symptom-ui-button__label">{t("add_new_medicine")}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default SortAndAddNew;